<template>
  <div>
    <v-tooltip v-if="tooltipText" top color="#f5b8b8"  content-class="tooltip-rounded">
      <template v-slot:activator="{ on, attrs }">
        <v-chip v-bind="attrs" v-on="on" :color="color" dark class="chip d-flex align-center justify-center">
          <v-icon class="mr-2" small>{{ icon }}</v-icon>
          {{ name }}
        </v-chip>
      </template>
      <span style="color: black">{{ tooltipText }}</span>
    </v-tooltip>

    <v-chip v-else :color="color" dark class="chip d-flex align-center justify-center">
      <v-icon class="mr-2" small>{{ icon }}</v-icon>
      {{ name }}
    </v-chip>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },  
  
  props: {
    icon: String,
    name: String,
    color: String, 
    tooltipText: String,
  },
};
</script>

<style scoped>
.chip {
  transition: all 0.2s ease;
  font-weight: 500;
  min-width: 262px;
}

.chip:hover {
  transform: scale(1.04);
}

.tooltip-rounded {
  border-radius: 16px !important;
}
</style>
